import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Call from '../../../hocs/call';
import { getELCsvStructure, setELStructureColumnType } from '../actions';
import {  EL_STEP_STRUCTURE } from '../constants';
import ELStructureStepTable from "./Table";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  step: state.scenes.easyLoading.step,
  structureColumns: state.scenes.easyLoading.structureColumns,
  srcFile: state.scenes.easyLoading.srcFile,
  permissions: state.app.user.permissions
}); 

const mapDispatchToProps = dispatch => ({
  fetchCsvStructure: ({separator, delimiter, hasHeader, csvPath, appLang}) =>
    dispatch(getELCsvStructure(separator, delimiter, hasHeader, csvPath, appLang)),
  onChange: (columnId, columnType, transColId, langCode) => 
    dispatch(setELStructureColumnType(columnId, columnType, transColId, langCode))  
});

const ELStructureStep = ({
                          appLanguage,
                          step,
                          structureColumns,
                          srcFile,
                          permissions,
                          fetchCsvStructure,
                          onChange
                        }) => {

  return (  
    <Call cb={fetchCsvStructure}
      cbParam={{
        separator: srcFile ? srcFile.separator : null,
        delimiter: (srcFile && srcFile.delimiter) ? srcFile.delimiter : null,
        hasHeader: true,
        csvPath: srcFile ? srcFile.csvPath : null,
        appLang: appLanguage
      }}
      disabled={  step !== EL_STEP_STRUCTURE || !srcFile || structureColumns}
    >
      <ELStructureStepTable
        structureColumns={structureColumns}
        permissions={permissions}
        onChange={onChange}
      >
      </ELStructureStepTable>
    </Call>  
  )};                      
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
  )(ELStructureStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/structure-step/index.jsx